import { States } from 'safe'
import {
  CLEAN_ITEMS,
  ExistencesTypes,
  SET_EXISTENCE,
} from '../actions/actionTypes'

export const initialState: States.Existence = {
  warehouse: {
    id: '0',
  },
  existences: [],
  numberOfPages: 0,
}

//eslint-disable-next-line
export default (
  state = initialState,
  action: ExistencesTypes
): States.Existence => {
  switch (action.type) {
    case SET_EXISTENCE:
      return action.payload
    case CLEAN_ITEMS:
      return {
        warehouse: {
          id: '0',
        },
        existences: [],
        numberOfPages: 0,
      }
    default:
      return state
  }
}
